<ng-template #dropDownOptions let-column>
  <div class="col-sm-12">
    <table class="table table-sm">
      <tbody>
        <tr *ngFor="let column of column.options; let idx = index;">
          <td>
            <div class="input-group input-group-sm">
              <span class="input-group-text option-key-value" translate>{{idx + 1}}</span>
              <input type="text" class="form-control" [placeholder]="'Value ' + idx" [(ngModel)]="column.value" />
            </div>
          </td>
          <td class="text-center align-middle">
            <button class="btn btn-sm text-danger" (click)="removeOption(column.id)"
              [disabled]="component.element.columns.length < 3">
              <i class="fas fa-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <button class="btn btn-link btn-sm" (click)="addColumnDropDownOption(column)">
      <i class="fas fa-plus me-2"></i> <span translate>Add Options</span>
    </button>
  </div>
</ng-template>
<div class="row mb-2">
  <label class="mb-1 col-sm-12" translate>Columns list</label>
  <div class="col-sm-12">
    <table class="table table-sm">
      <tbody>
        <tr *ngFor="let option of component.element.columns; let idx = index;">
          <td class="text-center align-middle">
            <button class="btn btn-sm text-danger" (click)="removeOption(option.id)"
              [disabled]="component.element.columns.length < 3">
              <i class="fas fa-trash"></i>
            </button>
          </td>
          <td>
            <div class="input-group input-group-sm">
              <span class="input-group-text option-key-value" translate>Id</span>
              <input type="text" class="form-control" [(ngModel)]="option.id" />
            </div>
            <div class="input-group input-group-sm">
              <span class="input-group-text option-key-value" translate>Name</span>
              <input type="text" class="form-control" [placeholder]="'Value ' + idx" [(ngModel)]="option.name" />
            </div>
            <div class="input-group input-group-sm">
              <span class="input-group-text option-key-value" translate>Type</span>
              <select class="form-select form-select-sm" [(ngModel)]="option.valueType">
                <option value="text" translate>Text</option>
                <option value="number" translate>Number</option>
                <option value="amount" translate>Amount</option>
                <option value="checkbox" translate>Checkbox</option>
                <option value="dropdown" translate>Dropdown</option>
                <option value="date" translate>Date</option>
                <option value="toggle" translate>Toggle</option>
              </select>
              <!-- droop down values configure -->
              <ng-container *ngIf="option.valueType == 'dropdown'">
                <ng-container *ngTemplateOutlet="dropDownOptions; context: { $implicit: option }"></ng-container>
              </ng-container>
            </div>
            <div class="input-group input-group-sm">
              <span class="input-group-text option-key-value" translate>Width</span>
              <input type="number" class="form-control" [placeholder]="" [(ngModel)]="option.width" />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <button class="btn btn-link btn-sm" (click)="addOption()">
      <i class="fas fa-plus me-2"></i> <span translate>Add column</span>
    </button>
  </div>
</div>
<div class="row mb-2">
  <label class="col-sm-6" translate>Field Name</label>
  <div class="col-sm-6">
    <div class="input-group">
      <input type="text" min="0" class="form-control form-control-sm" [(ngModel)]="component.element.field_name" />
    </div>
  </div>
</div>
<div class="row mb-2">
  <label class="col-sm-6" translate>Table color</label>
  <div class="col-sm-6">
    <div class="input-group">
      <span class="input-group-text" [style.background]="component.element.button_color"></span>
      <input class="form-control form-control-sm" [(colorPicker)]="component.element.button_color"
        (colorPickerChange)="onColorPickerChange($event)" [cpPosition]="'bottom'" [cpDisableInput]="true"
        [cpAlphaChannel]="'disabled'" [cpPositionOffset]="'-100%'" [value]="component.element.button_color" />
    </div>
  </div>
</div>
<div class="row mb-2">
  <label for="" class="col-sm-6" translate>Round corners</label>
  <div class="col-sm-6">
    <input type="number" min="0" class="form-control form-control-sm" [(ngModel)]="component.element.rounded_corners" />
  </div>
</div>
<div class="row mb-2">
  <label for="" class="col-sm-6" translate>Table width</label>
  <div class="col-sm-6">
    <select class="form-select form-select-sm" [(ngModel)]="component.element.button_size_type">
      <option value="auto" translate>Auto</option>
      <option value="full-width" translate>The full width</option>
      <option value="fixed" translate>Fixed size</option>
    </select>
  </div>
</div>
<div class="row mb-2" *ngIf="component.element.button_size_type === 'fixed'">
  <div class="col-sm-6 offset-6">
    <input type="number" min="0" class="form-control form-control-sm" [(ngModel)]="component.element.button_size" />
  </div>
</div>
<div class="row mb-2">
  <label for="" class="col-sm-6" translate>Alignment</label>
  <div class="col-sm-6">
    <div class="row g-0">
      <button class="col btn btn-primary btn-sm rounded-0"
        [ngClass]="{ active: component.element.alignment === 'left' }" (click)="component.element.alignment = 'left'">
        <i class="fas fa-align-left"></i>
      </button>
      <button class="col btn btn-primary btn-sm rounded-0"
        [ngClass]="{ active: component.element.alignment === 'center' }"
        (click)="component.element.alignment = 'center'">
        <i class="fas fa-align-center"></i>
      </button>
      <button class="col btn btn-primary btn-sm rounded-0"
        [ngClass]="{ active: component.element.alignment === 'right' }" (click)="component.element.alignment = 'right'">
        <i class="fas fa-align-right"></i>
      </button>
    </div>
  </div>
</div>
<hr />
<div>
  <label for="" class="mb-2" translate>The font of inscription</label>
  <div class="mb-2 d-flex justify-content-between">
    <input type="number" class="form-control form-control-sm" [(ngModel)]="component.element.font_size" min="8"
      style="width: 60px" />

    <app-font-options [component]="component"></app-font-options>
    <div>
      <button class="btn btn-primary btn-sm rounded-0" [ngClass]="{ active: component.element.font_bold }"
        (click)="component.element.font_bold = !component.element.font_bold">
        <i class="fas fa-bold"></i>
      </button>
      <button class="btn btn-primary btn-sm rounded-0" [ngClass]="{ active: component.element.font_italic }"
        (click)="component.element.font_italic = !component.element.font_italic">
        <i class="fas fa-italic"></i>
      </button>
    </div>
  </div>
</div>
<div class="row mb-2">
  <label for="" class="col-sm-6" translate>Text color</label>
  <div class="col-sm-6">
    <div class="input-group">
      <span class="input-group-text" [style.background]="component.element.text_color"></span>
      <input class="form-control form-control-sm" [(colorPicker)]="component.element.text_color" [cpPosition]="'bottom'"
        [cpDisableInput]="true" [cpPositionOffset]="'-100%'" [cpAlphaChannel]="'disabled'"
        [value]="component.element.text_color" />
    </div>
  </div>
</div>
<div class="row mb-2">
  <label for="" class="col-sm-6" translate>Border Width</label>
  <div class="col-sm-6">
    <div class="input-group">
      <input type="number" class="form-control form-control-sm" [(ngModel)]="component.element.border_width" min="0"
        style="width: 60px" />
    </div>
  </div>
</div>
<div class="row mb-2">
  <label for="" class="col-sm-6" translate>Border Style</label>
  <div class="col-sm-6">
    <div class="input-group">
      <select class="form-select form-select-sm" [(ngModel)]="component.element.border_style">
        <option value="solid" translate>Solid</option>
        <option value="dashed" translate>Dashed</option>
      </select>
    </div>
  </div>
</div>
<div class="row mb-2">
  <label for="" class="col-sm-6" translate>Border color</label>
  <div class="col-sm-6">
    <div class="input-group">
      <span class="input-group-text" [style.background]="component.element.border_color"></span>
      <input class="form-control form-control-sm" [(colorPicker)]="component.element.border_color"
        [cpPosition]="'bottom'" [cpDisableInput]="true" [cpPositionOffset]="'-100%'" [cpAlphaChannel]="'disabled'"
        [value]="component.element.border_color" />
    </div>
  </div>
</div>